import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Modal from '../modal/Modal'
import { TERMS_AND_CONDITION_EXPIRED_MESSAGE } from '../../utilities/termsAndConditionWarnings'
import styles from './index.module.scss'

export default function TermsAndConditionExpiredWarningModal ({
  isOpen,
  onCreateAnyways,
  onCancelAndGoToAccount,
  onCreateAndResend,
  onDismiss,
  doNotShowAgain,
  onDoNotShowAgainChange,
  isWorking = false,
  canDismiss = false
}) {
  useEffect(() => {
    if (!isOpen) return undefined

    function handleKeyDown (event) {
      if (event.key === 'Escape') {
        onDismiss()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, onDismiss])

  return (
    <Modal isOpen={isOpen} closeModal={() => {}}>
      <div
        className={cn('dis-panel', styles.dialog)}
        role='dialog'
        aria-modal='true'
        aria-labelledby='tcExpiredWarningTitle'>
        <i className={cn('material-icons-outlined', styles.icon)} aria-hidden='true'>error_outline</i>
        <p id='tcExpiredWarningTitle' className={styles.message}>
          {TERMS_AND_CONDITION_EXPIRED_MESSAGE}
        </p>
        <label className={styles.checkboxLabel}>
          <input
            type='checkbox'
            checked={doNotShowAgain}
            onChange={onDoNotShowAgainChange}
            disabled={isWorking || !canDismiss}
          />
          <span>Do Not Show Again</span>
        </label>
        <div className={styles.buttonRow}>
          <button
            type='button'
            className='dis-btn dis-btn-lg dis-btn-primary'
            onClick={onCreateAndResend}
            disabled={isWorking}>
            Create &amp; Resend
          </button>
          <button
            type='button'
            className='dis-btn dis-btn-lg dis-btn-primary-lt'
            onClick={onCreateAnyways}
            disabled={isWorking}>
            Create Anyways
          </button>
          <button
            type='button'
            className='dis-btn dis-btn-lg dis-btn-blank'
            onClick={onCancelAndGoToAccount}
            disabled={isWorking}>
            Cancel &amp; Go To Account
          </button>
        </div>
      </div>
    </Modal>
  )
}

TermsAndConditionExpiredWarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCreateAnyways: PropTypes.func.isRequired,
  onCancelAndGoToAccount: PropTypes.func.isRequired,
  onCreateAndResend: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  doNotShowAgain: PropTypes.bool.isRequired,
  onDoNotShowAgainChange: PropTypes.func.isRequired,
  isWorking: PropTypes.bool,
  canDismiss: PropTypes.bool
}
